import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const MuiDropdown = ({
  items,
  onItemClick,
  defaultLabel = 'Select',
  selectedValue,
  className = '',
  maxHeight = '200px'
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (key) => {
    onItemClick(key);
    handleClose();
  };

  const getSelectedLabel = () => {
    const selectedItem = items.find(item => item.key === selectedValue);
    return selectedItem ? selectedItem.label : defaultLabel;
  };

  return (
    <>
      <Button
        className={className}
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUpIcon style={{ marginRight: -5 }} /> : <KeyboardArrowDownIcon style={{ marginRight: -5 }} />}
      >
        {getSelectedLabel()}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        style={{ zIndex: 1000000003 }}
        PaperProps={{
          style: {
            maxHeight: maxHeight,
            overflowY: 'auto'
          }
        }}
      >
        {items.map((item) => (
          <MenuItem
            key={item.key}
            onClick={() => handleMenuItemClick(item.key)}
            selected={selectedValue === item.key}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MuiDropdown; 